<template>
  <div class="ac-page">
    <div class="ac-body">
      <h1 class="ac-title">阅读游戏账号注销须知</h1>

      <p v-if="hasPendingApply" class="pending-tip">
        当前账户已经提交注销申请，请勿重复提交
      </p>

      <div class="terms">
        <p class="terms-lead">{{ NOTICE.lead }}</p>
        <p v-for="(item, i) in NOTICE.items" :key="i" class="terms-item">
          <span class="terms-n">{{ i + 1 }}</span>{{ item }}
        </p>
      </div>
    </div>

    <div class="ac-footer">
      <label class="agree" @click="checked = !checked">
        <span class="check" :class="{ checked }" />
        我已同意上述注销须知
      </label>
      <div class="actions-row">
        <button class="ac-btn is-ghost" @click="onCancel">我不注销了</button>
        <button class="ac-btn is-primary" @click="onAgree">同意注销</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { NOTICE } from "./config";

export default {
  name: "AccountCancelNotice",
  data() {
    return {
      NOTICE,
      checked: false,
    };
  },
  computed: {
    // 最近一次注销申请仍在审核中（status=0）
    hasPendingApply() {
      return this.$store.state.accountCancel.latestCloseApplyStatus === 0;
    },
  },
  created() {
    if (!this.$store.state.accountCancel.closeToken) {
      this.$router.replace({ name: "gameJump-accountCancelLogin" });
    }
  },
  methods: {
    onCancel() {
      // 放弃注销：回到登录页（登录页 created 会清空用户信息）
      this.$router.replace({ name: "gameJump-accountCancelLogin" });
    },
    onAgree() {
      if (!this.checked) {
        Toast("请先勾选「我已同意上述注销须知」");
        return;
      }
      this.$router.push({ name: "gameJump-accountCancelForm" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.pending-tip {
  margin-top: 14px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(239, 62, 54, 0.08);
  color: $ac-brand;
  font-size: 13px;
  line-height: 1.5;
}

.terms {
  margin-top: 18px;
  padding: 20px 18px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(20, 25, 35, 0.05);
}

.terms-lead {
  margin-bottom: 16px;
  color: $ac-text;
  font-size: 14px;
  line-height: 1.7;
}

.terms-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 14px;
  color: #3a3f4a;
  font-size: 14px;
  line-height: 1.7;
  text-align: justify;

  &:last-child {
    margin-bottom: 0;
  }
}

.terms-n {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 2px;
  border-radius: 50%;
  background: $ac-brand;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.agree {
  display: inline-flex;
  align-items: center;
  margin-bottom: 16px;
  color: $ac-text;
  font-size: 14px;
}

.check {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  border: 1.5px solid #c2c7d0;
  border-radius: 4px;
  background: #fff;

  &.checked {
    border-color: $ac-brand;
    background: $ac-brand;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 14 14' fill='none'%3E%3Cpath d='M3 7.5l3 3 5-6' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
  }
}

.actions-row {
  display: flex;
  gap: 12px;

  .ac-btn {
    flex: 1;
  }

  .ac-btn + .ac-btn {
    margin-top: 0;
  }
}
</style>
